import React from "react"

import { Box } from "src/UILibrary"

import { IconProps } from "src/types/icon"

export const ArrowRightIcon: React.FC<IconProps> = ({ sx, width, height, color }: IconProps) => {
  return (
    <Box sx={{ ...sx }}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 11 22`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.18994 1L10.3923 8L1.18994 15"
          stroke={color || "white"}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </Box>
  )
}
